"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonaDemographicsFactory = void 0;
const Factory = require("factory.ts");
const ethnicity_factory_1 = require("./ethnicity.factory");
exports.PersonaDemographicsFactory = Factory.Sync.makeFactory({
    persona_id: Factory.each(i => i + 1),
    played_outside_us: true,
    country_of_birth: 'USA',
    disability: 'unspecified',
    military_status: 'none',
    ethnicities: ethnicity_factory_1.ethnicityFactory.buildList(1),
    citizenship_countries: ['USA', 'CAN']
});
